import * as React from "react";
const SvgMinusIcon = (props) => /* @__PURE__ */ React.createElement("svg", { id: "Layer_2", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", ...props }, /* @__PURE__ */ React.createElement("rect", { x: 21.68, y: 44.33, width: 51.96, height: 7 }));
export default SvgMinusIcon;
